<div class="row m-3 p-3">
    <div class="row">
        <div class="d-flex flex-column mb-4">
            <h2 class="sub-header-title">
                <div>
                    <span *ngIf="activate && !deactivateAndInactive">Activate</span>
                    <span *ngIf="activate && deactivateAndInactive">Update</span>
                    <span *ngIf="!activate && !deactivateAndInactive">Deactivate</span>
                    Propert<span *ngIf="selectedProperties.length === 1">y</span><span *ngIf="selectedProperties.length > 1">ies</span>
                </div>
            </h2>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col-12">
            <div class="d-flex flex-column">
                <div class="d-flex justify-content-start">
                    Are you sure you would like to proceed?
                </div>
            </div>
        </div>
    </div>
    <div class="mt-2 mb-2 d-flex justify-content-end">
        <button mat-raised-button class="cancel-finish-button" style="margin-right:12px" (click)="cancelUpdatePropertyStatus()">
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
        <button *ngIf="!activate || deactivateAndInactive" mat-raised-button class="warn-button" (click)="submitUpdatePropertyStatus(false)">
            <mat-icon>delete</mat-icon>
            Deactivate
        </button>
        <button *ngIf="activate || deactivateAndInactive" mat-raised-button class="action-button" (click)="submitUpdatePropertyStatus(true)">
            <mat-icon>add</mat-icon>
            Activate
        </button>
    </div>
</div>